import { useCallback, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Yousign } from 'helpers/yousign'
import dayjs from 'dayjs'
import classNames from 'classnames'
import api from 'helpers/api'
import style from './Signature.module.scss'

const Signature = () => {
  const { state } = useLocation()
  const signatureLink = state?.client?.signatureLink
  const hasHandledSignature = useRef(false)

  const onSignatureSuccess = useCallback(
    async data => {
      try {
        await Promise.all(state.adhesionId.map(async adhesionId => {
          await api.put({
            url: `/adhesions/${adhesionId}/signature/subscription/client`,
            data: {
              signature: 1,
              signatureHorodate: dayjs(data.timeStamp).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            },
            headers: { Authorization: `Bearer ${state.token}` },
          })
        }))
      } catch (error) {
        console.log('Update adhesion status error')
      }
    },
    [state],
  )


  useEffect(() => {
    if (signatureLink) {
      const yousign = new Yousign({
        signatureLink: signatureLink,
        iframeContainerId: 'signature-iframe',
        isSandbox: true, //To set if you use the sandbox environment
      })

      yousign.onSuccess(() => {
        if (hasHandledSignature.current) return
        hasHandledSignature.current = true
        onSignatureSuccess({ timeStamp: new Date() })
      })

      yousign.onError(() => {
        console.log('Error on signing the document')
      })
    }
  }, [state, onSignatureSuccess, signatureLink])


  return (
    <div
      className={classNames(style['signature-iframe'], !signatureLink && style.inactive)}
      id="signature-iframe"
    ></div>
  )
}

export default Signature
